exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#createNotification .map {\n  width: 710px;\n  height: 400px;\n}\n", ""]);

// exports
